"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BannerNotification = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const flex_1 = require("../layout/flex");
const styled_1 = __importDefault(require("../../styles/styled"));
const BannerNotification = ({ content }) => {
    return ((0, jsx_runtime_1.jsx)(StickyContainer, { children: content && (0, jsx_runtime_1.jsx)(BannerWrapper, { children: content() }) }));
};
exports.BannerNotification = BannerNotification;
const BannerWrapper = (0, styled_1.default)(flex_1.Row)(({ theme }) => ({
    padding: '16px 24px',
    height: '100%',
    boxShadow: theme.shadow.bottomLarge,
}));
const StickyContainer = (0, styled_1.default)('div')({
    width: '100%',
    position: 'sticky',
    top: 0,
    zIndex: 5,
    backgroundColor: 'white',
});
//# sourceMappingURL=banner_notification.js.map